import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=212f5a62&scoped=true"
import script from "./modify.vue?vue&type=script&lang=js"
export * from "./modify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f5a62",
  null
  
)

export default component.exports